function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "printer",
  transform: "translate(1.000000, 0.000000)",
  stroke: "currentColor",
  strokeWidth: 1
}, React.createElement("path", {
  d: "M2.66036866,15 L1.8,15 C0.80588745,15 0,13.5076158 0,11.6666667 L0,3.33333333 C0,1.49238417 0.80588745,0.5 1.8,0.5 L16.2,0.5 C17.1941125,0.5 18,1.49238417 18,3.33333333 L18,11.6666667 C18,13.5076158 17.1941125,15 16.2,15 L15,15",
  id: "Path"
}), React.createElement("rect", {
  id: "Rectangle",
  x: 3,
  y: 3,
  width: 12,
  height: 16
}), React.createElement("path", {
  d: "M8.75,9.5 L8.75,3.5",
  id: "Path",
  transform: "translate(8.625000, 6.875000) rotate(90.000000) translate(-8.625000, -6.875000) "
}), React.createElement("path", {
  d: "M8.75,12.5 L8.75,6.5",
  id: "Path",
  transform: "translate(8.625000, 9.875000) rotate(90.000000) translate(-8.625000, -9.875000) "
}), React.createElement("path", {
  d: "M8.75,15.5 L8.75,9.5",
  id: "Path",
  transform: "translate(8.625000, 12.875000) rotate(90.000000) translate(-8.625000, -12.875000) "
}), React.createElement("path", {
  d: "M10.1875,17.5625 L10.3125,13.6875",
  id: "Path",
  transform: "translate(10.062500, 15.937500) rotate(90.000000) translate(-10.062500, -15.937500) "
})));

var SvgErplyPrinter = function SvgErplyPrinter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgErplyPrinter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/erply_printer.9b0d60ee.svg";
export { ForwardRef as ReactComponent };